import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../../components/ui/Table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter } from '../../../components/ui/Dialog';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

type Props = {
  userId: string;
  companyPrimaryColor: string;
  t: any;
};

type State = {
  data: any[];
  selectedPageIndex: number;
  count: number;
  offset: number;
  expand: any;
  openNewTaskOnBoarding: boolean;
  dateValue: any;
  openNewTaskOffBoarding: boolean;
};

class SetUp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
      selectedPageIndex: 0,
      count: 10,
      offset: 0,
      expand: false,
      openNewTaskOnBoarding: false,
      openNewTaskOffBoarding: false,
      dateValue: new Date(),
    };
  }

  handleClickNewTaskOpenOnBoarding = () => {
    this.setState({ openNewTaskOnBoarding: true });
  };

  handleClickNewTaskCloseOnBoarding = () => {
    this.setState({ openNewTaskOnBoarding: false });
  };

  handleClickNewTaskOpenOffBoarding = () => {
    this.setState({ openNewTaskOffBoarding: true });
  };

  handleClickNewTaskCloseOffBoarding = () => {
    this.setState({ openNewTaskOffBoarding: false });
  };

  handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      this.setState({ expand: isExpanded ? panel : false });
    };

  onBoardingtasks = [
    {
      taskName: "Discuss the employee's experience.",
      taskType: "Hr Tasks",
      duration: "5 days",
    },
    {
      taskName: "Complete all new hire forms.",
      taskType: "Hr Tasks",
      duration: "5 days",
    },
  ];

  offBoardingtasks = [
    {
      taskName: "Transferring that employee's job responsibilities",
      taskType: "Hr Tasks",
      duration: "5 days",
    },
    {
      taskName: "Documenting and transferring responsibilities",
      taskType: "Hr Tasks",
      duration: "5 days",
    },
  ];

  render() {
    const { t, companyPrimaryColor } = this.props;

    return (
      <div className="flex flex-col gap-2.5 pt-5 me-8">
        <div className="flex flex-col gap-2.5 items-center">
          <div className="flex max-w-7xl w-full">
            <div className="flex flex-1 justify-center">
              <h2 className="text-2xl font-semibold text-primary">{t('On Boarding')}</h2>
            </div>
            <div className="flex justify-end">
              <Button
                variant="default"
                iconName="List"
                className="w-[150px]"
                style={{ backgroundColor: companyPrimaryColor }}
                onClick={this.handleClickNewTaskOpenOnBoarding}
              >
                {t('New Task')}
              </Button>
            </div>
          </div>
          <Table className="table-standard table-outline-rows table-compact border border-border rounded-lg max-w-7xl w-full">
            <TableHeader>
              <TableRow>
                <TableHead>{t('Task Description')}</TableHead>
                <TableHead>{t('Task Type')}</TableHead>
                <TableHead>{t('Duration')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {this.onBoardingtasks.map((row) => (
                <TableRow key={row.taskName}>
                  <TableCell>
                    <b>{row.taskName}</b>
                  </TableCell>
                  <TableCell>{row.taskType}</TableCell>
                  <TableCell>{row.duration}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Dialog
            open={this.state.openNewTaskOnBoarding}
            onOpenChange={(open) => { if (!open) this.handleClickNewTaskCloseOnBoarding(); }}
          >
            <DialogContent size="sm" aria-describedby={undefined}>
              <DialogHeader>
                <DialogTitle>{t('New On Boarding Task')}</DialogTitle>
              </DialogHeader>
              <DialogBody className="flex flex-col gap-4">
                <Input label={t('Task Type')} />
                <Input label={t('Task Description')} />
                <Input label={t('Task Duration')} />
              </DialogBody>
              <DialogFooter>
                <Button variant="outline" onClick={this.handleClickNewTaskCloseOnBoarding}>{t('Cancel')}</Button>
                <Button variant="default" onClick={this.handleClickNewTaskCloseOnBoarding}>{t('Add')}</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  userId: state.user.userId,
  companyPrimaryColor: state.user.companyPrimaryColor,
});

export default connect(mapStateToProps)(withTranslation()(SetUp));
